import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";
import {getAuth, GoogleAuthProvider} from "firebase/auth";
import { getPerformance } from "firebase/performance";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
 
  apiKey: "AIzaSyCruWKzEJp_NmnePVY4YP4q4eax_tMWze4",
  authDomain: "finalfinal-ls.firebaseapp.com",
  projectId: "finalfinal-ls",
  storageBucket: "finalfinal-ls.firebasestorage.app",
  messagingSenderId: "800840519367",
  appId: "1:800840519367:web:3a7386278cecfb72ca38e2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app); 
const auth = getAuth(app);
const perf = getPerformance(app);
const googleProvider = new GoogleAuthProvider();

export default app; 
export {db, storage, auth };